import type { WorkflowRun } from '../../contracts/routines.types';

export type RunState = 'needs_approval' | 'running' | 'done' | 'failed' | 'queued';

export const deriveRunState = (run: WorkflowRun, needsApproval = false): RunState => {
  if (needsApproval) return 'needs_approval';
  if (run.status === 'failed') return 'failed';
  if (run.status === 'closed') return 'done';
  if (run.status === 'running') return 'running';
  return 'queued';
};

export const isRunActive = (run: WorkflowRun, needsApproval = false): boolean => {
  const state = deriveRunState(run, needsApproval);
  return state === 'running' || state === 'needs_approval';
};

export const runNeedsApproval = (
  run: WorkflowRun,
  pendingApprovalRunIds: ReadonlySet<string>
): boolean => run.agent_run_id != null && pendingApprovalRunIds.has(run.agent_run_id);

export const isCompletedRoutineRun = (
  run: WorkflowRun,
  pendingApprovalRunIds: ReadonlySet<string>
): boolean => run.status === 'closed' && !runNeedsApproval(run, pendingApprovalRunIds);

/** True while a list row may still change — used for session-runs poll cadence.
 *  Terminality follows `status` only: null is the pre-first-turn queued state
 *  (`test_run_before_first_turn_is_queued`), and the list endpoint sets
 *  `closed`/`failed` when a run finishes. */
export const isRunNonTerminal = (run: WorkflowRun): boolean =>
  run.status !== 'closed' && run.status !== 'failed';
